<script>
  export let inline = false
  export let open = false;
</script>

{#if open}

<svg class:inline width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line stroke-width="2" class="svelte-5mglkl" x1="9" y1="9" x2="21" y2="21" />
  <line stroke-width="2" class="svelte-5mglkl" x1="9" y1="21" x2="21" y2="9" />
  <circle cx="15" cy="15" r="14" stroke-width="2"/>
</svg>

{:else}

<svg class:inline width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.4355 11.0918H16.252V22H14.4355V11.0918ZM14.4355 8.66992V6.84375H16.252V8.66992H14.4355Z" />
  <circle cx="15" cy="15" r="14" stroke-width="2"/>
</svg>

{/if}

<style lang="scss">
  svg {
    line { fill: $color-mint; }
    path { fill: $color-mint; }
    circle { stroke: $color-mint; }

    &.inline {
      height: 1em;
      position: relative;
      top: 0.1em;
      line { stroke: currentColor; }
      path { fill: currentColor; }
      circle { stroke: currentColor; }
    }
  }

</style>